import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LanguageTranslationModule } from './shared/language-translation/language-translation.module';
import { BildverifizierungService } from './services/bildverifizierung.service';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { MatBadgeModule } from '@angular/material/badge';
import { TableModule } from 'primeng/table';
import { MatTableModule } from '@angular/material/table';
import { SharedModule } from 'src/shared/shared.module';

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        SharedModule,
        AppRoutingModule,
        LanguageTranslationModule,
        MatToolbarModule,
        MatButtonModule,
        MatMenuModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatFormFieldModule,
        MatGridListModule,
        MatTooltipModule,
        MatCardModule,
        MatBadgeModule,
        TableModule,
        MatTableModule,
    ],
    providers: [BildverifizierungService],
    bootstrap: [AppComponent],
})
export class AppModule {}
